import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer, { clearAuthFromStorage, saveAuthToStorage, } from "./authSlice";
import userDataReducer from "./userDataSlice";
import permissionsReducer from "./permissionsSlice";
import accountSummaryReducer from "./accountSummarySlice";
import utilityReducer from "./utilitySlice";
import clientDataReducer from "./clientDataSlice";
import activeClientListReducer from "./activeClientListSlice";
import divergenceReducer from "./divergenceSlice";
import refreshReducer from "./refreshSlice";
import emailMarketingReducer from "./emailMarketingSlice"; // ✅ New
import campaignPreviewReducer from "./campaignPreviewSlice"; // ✅ New
import marketingCalendarReducer from './marketingCalendarSlice';
import emailReducer from "./emailSlice";
import clientAdApprovalReducer from "./clientAdApprovalSlice";
import accountPerformanceReducer from "./accountPerformanceSlice";
import accountPerformanceClientReportReducer from "./accountPerformanceClientReportSlice";
import accountPerformanceTrackerReducer from "./accountPerformanceTrackerSlice";
import opportunityReducer from "./opportunitySlice";
import emailConfigurationReducer from "./emailConfigurationSlice";
import goalReducer from "./goalSlice";
import moduleReducer from "./moduleSlice";
import metaAdAuditReducer from "./metaAdAuditSlice";
import meetingAgendaReducer from "./meetingAgendaSlice";
import meetingScorerReducer from "./meetingScorerSlice";
import adTestingReducer from "./adTestingSlice";
import aiReducer from "./aiSlice";
import syncLogReducer from "./syncLogSlice";
import affiliateProjectionReducer from "./affiliateprojectionslice";
import publisherTaggingReducer from "./publishertaggingslice";
import publisherReportingReducer from "./publisherReportingSlice";
import integrationCredentialsReducer from "./integrationCredentialsSlice";
import accountOverviewReducer from "./accountOverviewSlice";
import affiliateTrackerReducer from "./affiliateTrackerSlice";
import socialYtTrackerReducer from "./socialYtTrackerSlice";
import sampleTrackerReducer from "./sampleTrackerSlice";
import salesGoalReducer from "./salesGoalSlice";
import outreachTrackerReducer from "./outreachTrackerSlice";
import presentationReducer from "./presentationSlice";
import salesReportingReducer from "./salesReportingSlice";
import ltvReportReducer from "./ltvSlice"; // ✅ New
import commissionTrackerReducer from "./commissionTrackerSlice";
import optOutContactReducer from "./optOutContactSlice";
import affiliateClickImportReducer from "./affiliateClickImportSlice";
import monthlyProjectionReducer from "./monthlyProjectionSlice";
import billingSummaryReducer from "./billingSummarySlice";
import employeePerformanceReducer from "./employeePerformanceSlice";
import outreachPerformanceReducer from "./outreachPerformanceSlice";
// ================================
// ✅ STORE
// ================================
const appReducer = combineReducers({
    auth: authReducer,
    userData: userDataReducer,
    permissions: permissionsReducer,
    accountSummary: accountSummaryReducer,
    utility: utilityReducer,
    clientData: clientDataReducer,
    activeClientList: activeClientListReducer,
    divergence: divergenceReducer,
    refresh: refreshReducer,
    emailMarketing: emailMarketingReducer, // ✅ Added
    campaignPreview: campaignPreviewReducer, // ✅ Added
    marketingCalendar: marketingCalendarReducer, // ✅ Add karo
    email: emailReducer,
    clientAdApproval: clientAdApprovalReducer,
    modules: moduleReducer,
    accountPerformance: accountPerformanceReducer,
    accountPerformanceClientReport: accountPerformanceClientReportReducer,
    accountPerformanceTracker: accountPerformanceTrackerReducer,
    employeePerformance: employeePerformanceReducer,
    opportunity: opportunityReducer,
    emailConfiguration: emailConfigurationReducer,
    goals: goalReducer,
    metaAdAudit: metaAdAuditReducer,
    meetingAgenda: meetingAgendaReducer,
    meetingScorer: meetingScorerReducer,
    adTesting: adTestingReducer,
    ai: aiReducer,
    syncLog: syncLogReducer,
    affiliateProjection: affiliateProjectionReducer,
    publisherTagging: publisherTaggingReducer,
    publisherReporting: publisherReportingReducer,
    integrationCredentials: integrationCredentialsReducer,
    accountOverview: accountOverviewReducer,
    affiliateTracker: affiliateTrackerReducer,
    socialYtTracker: socialYtTrackerReducer,
    sampleTracker: sampleTrackerReducer,
    salesGoal: salesGoalReducer,
    outreachTracker: outreachTrackerReducer,
    presentation: presentationReducer,
    salesReporting: salesReportingReducer,
    ltv: ltvReportReducer, // ✅ Added
    commissionTracker: commissionTrackerReducer,
    optOutContact: optOutContactReducer,
    affiliateClickImport: affiliateClickImportReducer,
    monthlyProjection: monthlyProjectionReducer,
    billingSummary: billingSummaryReducer,
    outreachPerformance: outreachPerformanceReducer,
});
const rootReducer = (state, action) => {
    if (action.type === 'auth/logout') {
        // Reset the entire state to initial values on logout
        state = undefined;
    }
    return appReducer(state, action);
};
export const store = configureStore({
    reducer: rootReducer,
});
// ================================
// ✅ AUTH PERSISTENCE LOGIC
// ================================
let lastAuthSnapshot = store.getState().auth;
store.subscribe(() => {
    const nextAuth = store.getState().auth;
    // Avoid unnecessary writes
    if (nextAuth === lastAuthSnapshot)
        return;
    lastAuthSnapshot = nextAuth;
    const hasRealSession = Boolean(nextAuth?.isAuthenticated && nextAuth?.token);
    const hasOtpPending = Boolean(nextAuth?.requiresOtp &&
        !nextAuth?.isOtpVerified &&
        nextAuth?.token);
    if (!hasRealSession && !hasOtpPending) {
        clearAuthFromStorage();
        return;
    }
    saveAuthToStorage(nextAuth);
});
